import "../JSONTools/JSONformatter.css"
import ToolHeader from "../../Components/ToolHeader";
import { useState } from "react";
import "./Bcryptpassword.css";
import { Row, Col } from "react-bootstrap";

import { BcryptHashGenerate, BcryptHashVerify } from "../../Services/APIService";


const BcryptPassword = () => {
    const [message, setMessage] = useState("");
    const toolFav = { toolName: 'BCrypt Hasher', Iconpath: "/FileCodeRaw.svg" };
    const saltOptions = Array.from({ length: 20 }, (_, i) => i + 1);
    const [selectedSalt, setSelectedSalt] = useState(1);
    const [hashedOutput, setHashedOutput] = useState("");
    const [hashedPassword, setHashedPassword] = useState("");
    const [plainPassword, setPlainPassword] = useState("");
    const [isMatch, setIsMatch] = useState(null);
    const [isCopied, setIsCopied] = useState(false);
    const resultBoxClass = isMatch === null
        ? "result-box"
        : `result-box ${isMatch ? "match" : "no-match"}`;

    const renderInfoIcon = (tooltipText) => (
        <span className="info-tooltip-wrapper">
            <button
                type="button"
                className="info-icon"
            >
                i
            </button>
            <span className="bcrypt-tooltip">{tooltipText}</span>
        </span>
    );

    const generateHash = async () => {
        setHashedOutput("");
        setIsMatch(null);
        setHashedPassword("");
        setPlainPassword("");
        try {
            const payload = {
                password: message,
                cost: selectedSalt
            }
            const response = await BcryptHashGenerate(payload);
            setHashedOutput(response.data.hash);
        } catch (error) {
            console.log(error);
            setHashedOutput("Error generating hash: " + error.message);
        }
    };
    const handleMatch = async () => {
        try {
            const payload = {
                password: plainPassword,
                hash: hashedPassword
            }
            const response = await BcryptHashVerify(payload);
            setIsMatch(response.data.match);
        } catch (error) {
            setHashedOutput("Error generating hash: " + error.message);
        }
    };

    

    


    const copyToClipboard = async () => {
        if (!hashedOutput) return;
        await navigator.clipboard.writeText(hashedOutput);

        setIsCopied(true);
        setTimeout(() => {
            setIsCopied(false);
        }, 2000);
    };

    return (<>
        <Col>
            <ToolHeader title="BCrypt Hasher" description="Generate and verify BCrypt password hashes." toolFav={toolFav} />
            <Row className="Formatter bcrypt-formatter-row">
                <Col xs={12} lg={6} className="bcrypt-formatter-column">
                    <div className="hmac-card-header">
                        <span>Generate Bcrypt Hash</span>
                    </div>
                    <div className="hash-container">
                        {/* Input Section */}
                        <div className="section">
                            <label className="label">
                                Enter plain text to hash
                                {renderInfoIcon("Plain text password to hash, bcrypt truncates inputs longer than 72 bytes.")}
                            </label>

                            <textarea
                                className="text-input"
                                placeholder="Enter the Message..."
                                value={message}
                                onChange={(e) => setMessage(e.target.value)}
                            />
                        </div>

                        {/* Salt Rounds */}
                        <div className="section">
                            <label className="label">
                                Select the number of Salt Rounds
                                {renderInfoIcon("Higher salt rounds increase security, but make hashing and verification slower.")}
                            </label>

                            <div className="salt-grid">
                                {saltOptions.map((num) => (
                                    <button
                                        key={num}
                                        className={`salt-btn ${selectedSalt === num ? "active-salt" : ""
                                            }`}
                                        onClick={() => setSelectedSalt(num)}>
                                        {num}
                                    </button>
                                ))}
                            </div>
                        </div>

                        {/* Generate Button */}
                        <button className="generate-btn" onClick={generateHash}>
                            Generate Hash
                        </button>

                        {/* Output Section */}
                        <div className="section">
                            <div className="output-header">
                                <label className="label">Hashed Output</label>
                                <button
                                    className="copy-btn"
                                    onClick={copyToClipboard} >
                                    {isCopied ? "Copied!" : "Copy"}
                                    
                                </button>
                            </div>

                            <textarea
                                className="output-box"
                                value={hashedOutput}
                                placeholder="Hashed Output will appear here"
                                readOnly
                            />
                        </div>
                    </div>

                </Col>

                <Col xs={12} lg={6} className="bcrypt-formatter-column">
                    <div className="hmac-card-header">
                        <span>Verify BCrypt Hash</span>
                    </div>
                    <div className="password-container">
                        {/* Hashed Password Input */}
                        <div className="input-section">
                            <label>Enter the Bcrypt Hashed Password</label>
                            <textarea
                                placeholder="$2b$10$....."
                                value={hashedPassword}
                                onChange={(e) => setHashedPassword(e.target.value)}
                            />
                        </div>

                        {/* Plain Text Input */}
                        <div className="input-section">
                            <label>Enter the Plain Text Password</label>
                            <input
                                type="text"
                                placeholder="Enter plain text.."
                                value={plainPassword}
                                onChange={(e) => setPlainPassword(e.target.value)}
                            />
                        </div>

                        {/* Match Button */}
                        <button className="match-btn" onClick={handleMatch}>
                            Match
                        </button>

                        {/* Result Section */}
                        <div className="result-section">
                            <label>Result</label>
                            <div className={resultBoxClass}>
                                {isMatch === null ? "Match result will appear here." : isMatch === true ? "Password matches the bcrypt hash" : "Password does not matches the bcrypt hash"}
                            </div>
                        </div>
                    </div>
                </Col>
            </Row>
        </Col>
    </>
    );
}


export default BcryptPassword;
